import SectionCard from "./common/SectionCard";
import { getLang } from "../../../store/uiStore";
import "./RegionsTable.css";

export default function RegionsTable({ regions }) {
    const lang = getLang();
    const tr = {
        section: lang === "ru" ? "Статистика по регионам" : "Омори минтақаҳо",
        region: lang === "ru" ? "Регион" : "Минтақа",
        clinics: lang === "ru" ? "Клиники" : "Муассисаҳо",
        passport: lang === "ru" ? "Паспорта" : "Шиносномаҳо",
        legal: lang === "ru" ? "ЮЛ" : "ШҲ",
        individual: lang === "ru" ? "ИП" : "ШВ",
        total: lang === "ru" ? "Всего" : "Ҳамагӣ",
    };
    const getName = (item) => lang === "ru"
        ? (item.name_ru ?? item.name_tj ?? "")
        : (item.name_tj ?? item.name_ru ?? "");

    if (!regions?.length) {
        return null;
    }

    const totals = regions.reduce(

        (acc, region) => ({

            clinics: acc.clinics + region.clinics.count,

            passport: acc.passport + region.passport.count,

            legal: acc.legal + region.legal.count,

            individual: acc.individual + region.individual.count,

        }),

        {

            clinics: 0,

            passport: 0,

            legal: 0,

            individual: 0,

        }

    );

    const passportPercent =
        totals.clinics > 0
            ? ((totals.passport / totals.clinics) * 100).toFixed(1)
            : 0;

    return (

        <SectionCard title={tr.section}>

            <div className="table-responsive analytics-table">

                <table className="table table-hover align-middle mb-0">

                    <thead className="table-light">

                        <tr>

                            <th>{tr.region}</th>

                            <th className="text-center">{tr.clinics}</th>

                            <th className="text-center">{tr.passport}</th>

                            <th className="text-center">{tr.legal}</th>

                            <th className="text-center">{tr.individual}</th>

                        </tr>

                    </thead>

                    <tbody>

                        {regions.map(region => (


                            <tr
                                key={region.id}
                                style={{
                                    transition: "background-color .15s ease",
                                }}
                            >

                                <td>

                                    <div className="region-name">

                                        <span className="region-dot" />

                                        {getName(region)}

                                    </div>

                                </td>

                                <td className="text-center fw-semibold">

                                    {region.clinics.count}

                                </td>

                                <td className="text-center">

                                    <div className="fw-semibold">

                                        {region.passport.count}

                                    </div>

                                    <div className="percent-badge mt-1">

                                        {region.passport.percent}%

                                    </div>

                                </td>

                                <td className="text-center fw-semibold">

                                    {region.legal.count}

                                </td>

                                <td className="text-center fw-semibold">

                                    {region.individual.count}

                                </td>

                            </tr>

                        ))}

                    </tbody>

                    <tfoot>

                        <tr className="table-light fw-bold">

                            <td>

                                Всего

                            </td>

                            <td className="text-center">

                                {totals.clinics}

                            </td>

                            <td className="text-center">

                                <div className="fw-bold">

                                    {totals.passport}

                                </div>

                                <div className="percent-badge mt-1">

                                    {passportPercent}%

                                </div>

                            </td>

                            <td className="text-center">

                                {totals.legal}

                            </td>

                            <td className="text-center">

                                {totals.individual}

                            </td>

                        </tr>

                    </tfoot>

                </table>

            </div>

        </SectionCard>

    );

}
